/* eslint-disable axo-frontend/directory-structure */
import {
  InsuranceContext,
  InsuranceState,
  insuranceInitialState,
  reducer,
} from '@axo/insurance/feature/providers';
import { PageSpinner } from '@axo/insurance/ui';
import { insurance } from '@axo/shared/data-access/types';
import { LoadedLoanApplication } from '@axo/shared/feature/providers';
import { ReactNode, useReducer } from 'react';
import { InsuranceContent } from './InsuranceContent';

export type OnEnd = {
  action: (params?: { token?: string; uid?: string }) => void;
  summaryButtonText?: string;
};

export type InsuranceProviderProps = {
  children: ReactNode;
  onEnd: OnEnd;
  spinner?: ReactNode;
  sourceTag: insurance.InsuranceSourceTag;
  initialState?: InsuranceState;
  application?: LoadedLoanApplication;
};

export function InsuranceProvider({
  children,
  onEnd,
  spinner = <PageSpinner />,
  sourceTag,
  initialState = insuranceInitialState,
  application,
}: InsuranceProviderProps) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <InsuranceContext.Provider value={{ state, dispatch }}>
      <InsuranceContent
        {...{ children, onEnd, spinner, sourceTag, application }}
      />
    </InsuranceContext.Provider>
  );
}
